import { BellIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNotifications } from "./useNotifications";

import echo from "@/lib/echo";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import toast from "react-hot-toast";
import NotificationModal from "../organisms/notificationModal";
import { useRouter } from "next/router";

export default function NotificationBell() {
  const { notifications } = useNotifications();
  const { user } = useAuth();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const queryClient = useQueryClient();
  const router = useRouter();

  useEffect(() => {
    if (!user?.id) return;

    const channel = `tasks.${user?.id}`;

    echo
      .private(channel)
      .stopListening(".taskAssigned")
      .listen(".taskAssigned", () => {
        queryClient.invalidateQueries("notifications");
        if (router.pathname !== "/ai-mode") {
          toast.success("New Task assigned to you.", {
            position: "top-right",
          });
        }
      });

    () => echo.leaveChannel();
  }, [user, router]);



  return (
    <>
      <NotificationModal
        open={notificationOpen}
        handleClose={() => setNotificationOpen(false)}
      />
      {notifications?.length > 0 && (
        <div
          className="cursor-pointer rounded-[46px] px-[1.3rem] py-[0.5rem] bg-[#f9fafb] dark:bg-accent  border border-[var(--border-100)] dark:border-input text-foreground text-[1.4rem] font-medium leading-[2rem] text-center"
          onClick={() => {
            setNotificationOpen(true);
          }}
        >
          <p className="flex text-red-600 items-center justify-center gap-3">
            <BellIcon className="size-8" />
            <span>
              {notifications?.length > 0 ? notifications?.length : ""}
            </span>
          </p>
        </div>
      )}
    </>
  );
}
